import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';
import { paths } from 'src/app/___LOGIC/__api/_apiConfig/api-types';
import { environment } from 'src/environments/environment';
import { SessionBootstrapService } from '../__init/session-bootstrap.service';

type LoginRequest  = paths['/v1/auth/login']['post']['requestBody']['content']['application/json'];
type LoginResponse = paths['/v1/auth/login']['post']['responses']['200']['content']['application/json'];

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(false);
  private userId: number | null = null;
  loading = false;
  private accessToken: string | null = null;
  private base = environment.apiUrl;

  get token() { return this.accessToken; }

  constructor(private http: HttpClient,private router: Router, private commonFunctions: FunctionsService,private resolver: ResolverService,private bootstrap: SessionBootstrapService) { }

  setToken(t: string | null) { this.accessToken = t; }

  private baseHeaders() {
    const h: Record<string, string> = { 'X-Client': environment.apiClient};
    if (environment.apiKey) h['X-API-Key'] = environment.apiKey;
    return new HttpHeaders(h);
  }

  login(username: string, password: string) {
    const body: LoginRequest = { username, password };
    const headers = this.baseHeaders().set('Content-Type', 'application/json');
    return this.http.post<LoginResponse>(`${this.base}/v1/auth/login`, body,{headers} );
  }

  tryLogin(loginObj) {

    this.loading = true;
    this.login(loginObj.username, loginObj.password).subscribe({
      next: res => {
        this.loading = false;
        this.setToken(res.access_token);
        // (optional) store expiry & user too
        this.bootstrap.load();
        this.loggedIn.next(true);
        this.userId = res.user.id;
        this.commonFunctions.setSelectedClientId(this.userId);    
        this.router.navigate(['/client-board']);
      },
      error: (err) => { 
        this.loading = false;
        /* this.guiFlow.openSimpleSnackBar(err.error,null,null); */
        console.log(err);
        /* your HttpErrorInterceptor already shows a toast */ }
    });
  }

  refresh() {
    return this.http.post<{access_token:string; expires_in:number}>(
      `${this.base}/v1/auth/refresh`,
      {},
      { headers: this.baseHeaders() }
    );
  }

  expireTokenForTest() {
    debugger
    this.setToken('EXPIRED_TOKEN');
  }


  loginOld(email: string, password: string): Observable<any> {
    return this.http.post<any>('https://dashboard.voyjaleas.com/api-dashboard/auth/login.php', { email, password }, { withCredentials: true } ) /*  */
      .pipe(
        map(response => {
          
          if (response.user_id) {
            this.loggedIn.next(true);
            this.userId = response.user_id;
            this.commonFunctions.setSelectedClientId(this.userId);
          }
          return response;
        })
      );
  }

  checkSession(): Observable<any> {
    return this.http.get<any>('https://dashboard.voyjaleas.com/api-dashboard/auth/check_session.php', { withCredentials: true })
      .pipe(
        map(response => {
          this.loggedIn.next(response.loggedIn);
          this.userId = response.user_id || null;
          this.commonFunctions.setSelectedClientId(this.userId);
          return response;
        })
      );
  }

  closeSession(){
    //document.cookie = 'authToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    //this.commonFunctions.setSelectedClientId(null);
    //this.deleteAllCookies();
    this.logout().subscribe(
      response => {
        this.loggedIn.value == false? this.commonFunctions.setSelectedClientId(null) : console.log('Error en close session');
        this.loading = false;
        this.router.navigate(['/loading']); // Redirect after login;
        // Clear user session (e.g., tokens)
        localStorage.removeItem('authToken');
        sessionStorage.clear();

        // Clear the resolver cache
        this.resolver.clearCache();
      }
    );
  }
  

  logout(): Observable<any> {
    return this.http.get<any>('https://app.voyjaleas.com/myapp/auth/logout.php', { withCredentials: true })
      .pipe(
        map(response => {
            this.loggedIn.next(false);
            return response;
        })
      );
  }

}


